
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/equity_calculator",
      function () {
        return require("private-next-pages/equity_calculator.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/equity_calculator"])
      });
    }
  